<template lang="pug">
  #section1.section
    #s1s1
      #s1s1a1.group
        //img blocks
        #s1s1a1b0
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/maps/atoyac-mob.png")
        #s1s1a1b0-1
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/maps/elquemado.png")
        //text blocks
        #s1s1a1b1
          .fake-header
          .block  
            .slide
              p.bold.small Las poblaciones de Guerrero, en especial las del municipio de Atoyac de Álvarez donde se encuentra El Quemado, históricamente han sido vulnerables a sistemas que controlan su autodeterminación socioeconómica y política.
          .fake-footer
        
      #s1s1a2.group
        //backgoound
        #s1s1a2.background
          .block
            .slide
              .backgroundImg
        //text blocks
        #s1s1a2b1   
          .fake-header
          .block  
            .slide
              p.bold.small La Revolución Mexicana sembró en el imaginario de los habitantes de la Costa Grande un ímpetu por reivindicar libertades civiles y derechos sociales, que al ser reprimidas con violencia, estallaron en múltiples luchas sociales, algunas de ellas armadas.
          .fake-footer
        #s1s1a2b2
          .fake-header
          .block  
            .slide
              p.bold.small Estos movimientos agraristas y sus deseos motivaron a los campesinos y sus familias a fundar sus propios pueblos lejos del control agrícola de los caudillos hacendarios y los poderes políticos que los apoyaban, así como de la violencia que ejercían sus “guardias blancas”.
          .fake-footer
    #s1s2
      #s1s2a1.group
        // backgrounds
        #s1s2a1b1.background
          .block  
            .slide
              .backgroundImg
        #s1s2a1b2.background
          .block  
            .slide
              .backgroundImg
        
        // text blocks
        #s1s2a1b3.text
          .fake-header
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/maps/Mapa 1.2.1 Villa Guerrero_00103.png")
              p.bold.small El más emblemático de estos pueblos, La Tamalera o “Colonia Agrícola Juan R. Escudero”, fue incendiado por el Ejército en abril de 1934.
          .fake-footer
        #s1s2a1b4.text
          .fake-header
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/maps/Mapa 1.2.1 Villa Guerrero_00195.png")
              p.bold.small Sus habitantes se dispersaron por la sierra guerrerense y algunos fundaron Villa Guerrero, donde exigieron que se respetara la repartición agraria.
          .fake-footer
        #s1s2a1b5.text
          .fake-header
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/maps/Mapa 1.2.1 Villa Guerrero_00284.png")
              p.bold.small Sin embargo, las guardias blancas atacaron en tres ocasiones a Villa Guerrero, incendiando sus casas de bajareque.
          .fake-footer
        #s1s2a1b6.text
          .fake-header
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/maps/Mapa 1.2.1 Villa Guerrero_00446.png")
              p.bold.small En su cuarta fundación, los campesinos decidieron reconstruir sus casas con adobe y cambiaron el nombre de su pueblo a 
                span.green “El Quemado”
                | .
          .fake-footer
      #s1s2a2.group
        // backgrounds
        #s1s2a2b1.background
          .block  
            .slide
              .backgroundImg
        //img block
        #s1s2a2b0
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/Mapa UASCA 1940_Mb.jpg")
        // text blocks
        #s1s2a2b2
          .fake-header
          .block  
            .slide
              p.bold.small En agosto de 1939, el gobierno federal&nbsp;
                span.green concedió a los habitantes de El Quemado el carácter de ejido&nbsp;
                | y les otorgó armas para formar una guardia rural que les permitiera defenderse ante futuros ataques.
          .fake-footer
        #s1s2a2b3
          .fake-header
          .block  
            .slide
              p.bold.small Durante un tiempo, hubo paz en El Quemado. Los campesinos dejaron las armas y se dedicaron a cultivar sus propias tierras con el objetivo de llevar una vida digna.
          .fake-footer
    #s1s3
      #s1s3a1.group
        // animation
        #s1s3a1-container.animation.init(data-path="/assets/section1/s1s3a1/" data-speed="0.1" data-count="212")
        #s1s3a1b0.background
         .block  
           .slide
             .backgroundImg
        #s1s3a1b00.background
         .block  
           .slide
             .backgroundImg
        // text blocks
        #s1s3a1b1
          .fake-header
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/fiebre.png")
              p.bold.small.uppercase.text-center De 1959 a 1979, México mantuvo un crecimiento anual del 7.1% del PIB. 
          .fake-footer
        #s1s3a1b2
          .fake-header
          .block  
            .slide
              p.bold.small La extracción de riqueza, sin embargo, se logró gracias al subsidio de la mano de obra de poblaciones como las de El Quemado, quienes a pesar de ser dueñas de sus tierras, conforme se industrializaron los mercados agrícolas, se vieron obligados a vender sus productos a corporaciones que abarataban sus cosechas.
          .fake-footer
        #s1s3a1b3
          .fake-header
          .block  
            .slide
              p.bold.small Ante el resurgimiento de esta desigualdad, los campesinos quedaron nuevamente vulnerables a la explotación ilegal de su trabajo.
          .fake-footer
        #s1s3a1b4
          .fake-header
          .block  
            .slide
              p.bold.small “Irresolución y repetición caracterizan la historia guerrerense”
                br
                span.green – A. Aviña, Specters of Revolution
          .fake-footer
      #s1s3a2.group 
        // background
        #s1s3a2b1.background
          .block  
            .slide
              .backgroundImg
        // img block
        #s1s3a2b4
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/[1.3.3] 19601022 (Diario de Acapulco) p1_MB.jpg") 
        // text block
        #s1s3a2b2
          .fake-header
          .block  
            .text-slide
              p.bold.small(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              ) A finales de la década de 1950 comenzaron a organizarse los campesinos guerrerenses, resultando en una primera
                span.green &nbsp;huelga estudiantil en 1960
                | &nbsp;en Chilpancingo que fue violentamente reprimida.
          .fake-footer
        // img block
        #s1s3a2b4-1
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/[1.3.3] 19601231 (Excelsior) p1_MB.jpg")
        #s1s3a2b3
          .fake-header
          .block  
            .text-slide
              p.bold.small(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              ) Los 13 muertos asesinados aquel día marcaron el primer acto de contrainsurgencia del Estado mexicano y el partido en el poder, el Partido Revolucionario Institucional, en el estado de Guerrero.
          .fake-footer
        #s1s3a2b5
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/[1.3.3] 19601126 (Trópico) p1_Mb.jpg")
        #s1s3a2b6
          .fake-header
          .block  
            .text-slide
              p.bold.small(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              ) El gobierno mexicano saboteó las estrategias políticas de los movimientos sociales mediante fraudes electorales, campañas mediáticas y disolución de protestas. 
          .fake-footer

      #s1s3a3.group
        //background
        #s1s3a3b1.background
          .block  
            .slide
              .backgroundImg

        //img block
        #s1s3a3b4
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/[1.3.4] 19670524 (Diario de Acapulco) Mb.jpg")
        
        // text block
        #s1s3a3b2
          .fake-header
          .block  
            .text-slide
              p.bold.small(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              ) El gobierno mexicano saboteó las estrategias políticas de los movimientos sociales mediante fraudes electorales, campañas mediáticas y disolución de protestas. 
          .fake-footer
        // img block        
        #s1s3a3b5
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/[1.3.4]-19670527-(Diario-de-Acapulco)-p1_Mbjpg.jpg")
        #s1s3a3b3
          .fake-header
          .block  
            .text-slide
              p.bold.small(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              ) Su intención fue mostrar&nbsp;
                span.green una pedagogía autoritaria:&nbsp;
                | enseñar y convencer que es mejor estar con el gobierno que en su contra.
          .fake-footer
        
       
        //- #s1s3a3b6
        //-   .block  
        //-     .slide
        //-       img(
        //-         data-sal="fade"
        //-         data-sal-delay="50"
        //-         data-sal-easing="ease"
        //-         src="/assets/section1/s1s3a3/images/img3.jpg")
      
      #s1s3a4.group
        //background
        #s1s3a4b1.background
          .block  
            .slide
              .backgroundImg
        // img block
        #s1s3a4b5
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/1.3.5_Asset 21_mb.jpg")
        // text block
        #s1s3a4b2
          .fake-header
          .block  
            .text-slide
              p.bold.small(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              ) Sin embargo, la lucha social continuó, y la respuesta del Estado fue escalando, llegando a momentos de quiebre donde destaca&nbsp; 
                span.green la masacre de padres de familia de la Primaria Alarcón&nbsp;
                | el 18 de mayo de 1967 en Atoyac de Álvarez.
          .fake-footer
        //img block
        #s1s3a4b6
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/1.3.5_Asset 19_Mb.jpg")
        #s1s3a4b3
          .fake-header
          .block  
            .text-slide
              p.bold.small(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              ) Ante los repetidos hechos de violencia, líderes sociales como&nbsp;
                span.green Lucio Cabañas y Genaro Vázquez&nbsp;
                | decidieron cambiar su estrategia política y optar por&nbsp;
                span.green la guerrilla como forma de lucha.
          .fake-footer
        //img block
        #s1s3a4b7
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/1.3.6-Asset-1_MB.jpg")
        #s1s3a4b4
          .fake-header
          .block  
            .text-slide
              p.bold.small(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              ) Para inicios de la década de 1970, el Estado mexicano cambió su concepción de los conflictos sociales, ubicándolos como&nbsp;
                span.green potencialmente subversivos&nbsp;
                | y comenzó a diseñar sus respuestas&nbsp;
                span.green con una lógica de eliminación.
          .fake-footer
        //- #s1s3a4b8
        //-   .block  
        //-     .slide
        //-       img(
        //-         data-sal="fade"
        //-         data-sal-delay="50"
        //-         data-sal-easing="ease"
        //-         src="/assets/section1/s1s3a4/images/img4.jpg")
      
      #s1s3a5.group
        // animation
        //#s1s3a5-container.animation.init(data-path="/assets/section1/s1s3a5/" data-speed="0.7" data-count="158")

        // backgrounds
        #s1s3a5b1.background
          .block  
            .slide
              .backgroundImg
        
        // text blocks
        #s1s3a5b2
          .fake-header
          .block  
            .slide
              p.bold.smaller.uppercase Esta modificación implicó un proceso de aprendizaje, adaptación y radicalización de las dependencias de seguridad nacional, como la Dirección Federal de Seguridad (DFS), para&nbsp;
                span.green dar forma a la contrainsurgencia.
          .fake-footer
        //img blocks
        #s1s3a5b3
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/maps/Mapa 1.3.6 Contrainsurgencia 00141.png")
        #s1s3a5b4
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/maps/Mapa 1.3.6 Contrainsurgencia 00234.png")
        #s1s3a5b5
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/maps/Mapa 1.3.6 Contrainsurgencia 00324.png")

        
      #s1s3a6.group
        // backgrounds
        #s1s3a6b1.background
          .block  
            .slide
              .backgroundImg
        
        // text block
        #s1s3a6b2
          .fake-header
          .block  
            .text-slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/MatanzaCopreros1967-Mb.jpg")
              p.bold.small(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              ) “Ganar los corazones y mentes de los campesinos mientras torturaban y asesinaban sus cuerpos.”
                br
                span.green – A. Aviña, Specters of Revolution
          .fake-footer
        // img block
        #s1s3a6b4
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/1.3.6-Asset-7_Mb.jpg")
        #s1s3a6b3
          .fake-header
          .block  
            .text-slide
              p.bold.small(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              ) Una de las más urgentes acciones del Ejército fue retirarle las armas a las guardias rurales, pero también el control de la región a través de la construcción de carreteras, cuarteles militares e infraestructura de telecomunicaciones.
          .fake-footer

        //img block
        #s1s3a6b5
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Intro-Section1/1.3.6-Asset-6_Mb.jpg")
</template>
<script>
import sal from 'sal.js'

export default {
  name: "Section1",
  methods: {
    initialize() {
      sal({
        threshold: 0.7,
        once: false,
      });
    }
  },
  mounted() {
    this.initialize();
  }
}
</script>
<style lang="scss" scoped>
#section1 {
  background-color: #13322b;
}

// SUBSECTION 1
#s1s1a1 {
  min-height: 300vh;
  #s1s1a1b0 {
    .block {
      @include blockin(100%, 40%, 5%, 0%);
      img {
        @include blockinImg(95%, 60vh, 30%);
      }
    }
  }
  #s1s1a1b0-1 {
    .block {
      @include blockin(100%, 40%, 50%, 0%);
      img {
        @include blockinImg(85%, 60vh, 15%);
      }
    }
  }
  #s1s1a1b1 {
    .fake-header {
      @include fakinH(15vh, -10vh);
    }
    .fake-footer {
      @include fakinF(15vh, 5%);
    }
    .block {
      @include blockin(100%, 90%, 0%, 0%);
      p {
        @include blockinP(80%, 70vh, 10%);
      }
    }
  }
}
#s1s1a2 {
  min-height: 250vh;
   #s1s1a2.background {
    .block {
      @include blockin(100%, 100%, 0%, 0%);
      .backgroundImg {
        background-image: linear-gradient(to bottom, rgba(9, 27, 22, 0.95), rgba(9, 27, 22, 0.95)), url("/assets/Mobile/Intro-Section1/Carrusel Hemerográfico_1_Mb.jpg");
        background-repeat: repeat-x;
      }
    }
  }
  #s1s1a2b1 {
    .fake-header {
      @include fakinH(2vh, -4vh);
    }
    .fake-footer {
      @include fakinF(5vh, 45%);
    }
    .block {
      @include blockin(100%, 50%, 0%, 0%);
      p {
        @include blockinP(80%, 40%, 10%);
      }
    }
  }
  #s1s1a2b2 {
    .fake-header {
      @include fakinH(3vh, 32%);
    }
    .fake-footer {
      @include fakinF(3vh, 0);
    }
    .block {
      @include blockin(100%, 50%, 50%, 0%);
      p {
        @include blockinP(80%, 40%, 10%);
      }
    }
  }
}


// SUBSECTION 2
#s1s2a1 {
  min-height: 500vh;
  #s1s2a1b0 {
    .block {
      @include blockin(100%, 100%, 0%, 0%);
      video {
        @include blockinImg(80%, 40vh, 22%);
      }
    }
  }
  #s1s2a1b1.background {
    overflow: visible !important;
    .block {
      @include blockin(100%, 50%, 0%, 0%);
      .backgroundImg {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.79), rgba(0, 0, 0, 0.79)), url("/assets/Mobile/Intro-Section1/Colonia Juan R escudero 20jul21930 archivo gral agrario ing armando gzlz guerra_MB.jpg"); 
      }
    }
  }
  #s1s2a1b2.background {
    .block {
      @include blockin(100%, 50%, 50%, 0%);
      .backgroundImg {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.79), rgba(0, 0, 0, 0.79)), url("/assets/section1/s1s2a1/backgrounds/background2.jpg");
      }
    }
  }
  #s1s2a1b3 {
    .fake-header {
      @include fakinH(18vh, -3%);
    }
    .fake-footer {
      @include fakinF(1vh, 74%);
    }
    .block {
      @include blockin(100%, 20%, 3%, 0%);
      p {
        @include blockinP(80%, 66vh, 10%);
      }
      img {
        @include blockinImg(95%, 60vh, 28%);
      }
    }
  }
  #s1s2a1b4 {
    .fake-header {
      @include fakinH(1vh, 22%);
    }
    .fake-footer {
      @include fakinF(1vh, 51%);
    }
    .block {
      @include blockin(100%, 19%, 28%, 0%);
      p {
        @include blockinP(80%, 68vh, 10%);
      }
      img {
        @include blockinImg(95%, 60vh, 28%);
      }
    }
  }
  #s1s2a1b5 {
    .fake-header {
      @include fakinH(2vh, 45%);
    }
    .fake-footer {
      @include fakinF(2vh, 26%);
    }
    .block {
      @include blockin(100%, 19%, 53%, 0%);
      p {
        @include blockinP(80%, 68vh, 10%);
      }
      img {
        @include blockinImg(95%, 60vh, 28%);
      }
    }
  }
  #s1s2a1b6 {
    .fake-header {
      @include fakinH(2vh, 72%);
    }
    .fake-footer {
      @include fakinF(9vh, 0);
    }
    .block {
      @include blockin(100%, 19%, 78%, 0%);
      p {
        @include blockinP(80%, 68vh, 10%);
      }
      img {
        @include blockinImg(95%, 60vh, 28%);
      }
    }
  }
}
#s1s2a2 {
  min-height: 300vh;
  #s1s2a2b0 {
    .block {
      @include blockin(100%, 90%, 0%, 0%);
      img {
        @include blockinImg(80%, 50vh, 20vh);
      }
    }
  }
  #s1s2a2b1.background {
    .block {
      @include blockin(100%, 100%, 0%, 0%);
      .backgroundImg {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.79), rgba(0, 0, 0, 0.79)), url("/assets/Mobile/Intro-Section1/1.2.3-Paz-y-Prosperidad_Mb.jpg");
        background-repeat: repeat-x;
      }
    }
  }
  #s1s2a2b2 {
    .fake-header {
      @include fakinH(5vh, -10%);
    }
    .fake-footer {
      @include fakinF(5vh, 55%);
    }
    .block {
      @include blockin(100%, 55%, 0, 0%);
      p {
        @include blockinP(80%, 70%, 10%);
      }
    }
  }
  #s1s2a2b3 {
    .fake-header {
      @include fakinH(5vh, 10%);
    }
    .fake-footer {
      @include fakinF(5vh, 18%);
    }
    .block {
      @include blockin(100%, 80%, 0%, 0%);
      p {
        @include blockinP(80%, 72%, 10%);
      }
    }
  }
}


// SUBSECTION 3
#s1s3 {
  background-image: linear-gradient(to bottom, #484848, #484848);
  canvas {
    filter: brightness(0.8);
  }
}
#s1s3a1 {
  min-height: 500vh;
   #s1s3a1b0.background {
    .block {
      @include blockin(100%, 33%, 0%, 0%);
      .backgroundImg {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.79), rgba(0, 0, 0, 0.79)), url("/assets/Mobile/Intro-Section1/1.3.1 ¿El Milagro Mexicano__Mb.jpg");
        background-size: contain; 
      }
    }
  }
  #s1s3a1b00.background {
      .block {
        @include blockin(100%, 67%, 33%, 0%);
        .backgroundImg {
          background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.79), rgba(0, 0, 0, 0.79)), url("/assets/Mobile/Intro-Section1/1.3.1 ¿El Milagro Mexicano__.Mbjpg.jpg");
          background-size: contain;         
        }
      }
    }
  #s1s3a1b1 {
    .fake-header {
      @include fakinH(18vh, -15vh);
    }
    .fake-footer {
      @include fakinF(5vh, 60%);
    }
    .block {
      @include blockin(100%, 33%, 0, 0%);
      p {
        @include blockinP(80%, 60vh, 10%);
      }
      img {
        @include blockinImg(80%, 62vh, 24%);
      }
    }
  }
  #s1s3a1b2 {
    .fake-header {
      @include fakinH(5vh, 25%);
    }
    .fake-footer {
      @include fakinF(5vh, 42%);
    }
    .block {
      @include blockin(100%, 45%, 18%, 0%);
      p {
        @include blockinP(80%, 40vh, 10%);
      }
    }
  }
  #s1s3a1b4 {
    .fake-header {
      @include fakinH(5vh, 45%);
    }
    .fake-footer {
      @include fakinF(5vh, 3%);
    }
    .block {
      @include blockin(100%, 52%, 48%, 0%);
      p {
        @include blockinP(80%, 36%, 10%);
      }
    }
  }
  #s1s3a1b3 {
    .fake-header {
      @include fakinH(5vh, 50%);
    }
    .fake-footer {
      @include fakinF(5vh, 3%);
    }
    .block {
      @include blockin(100%, 52%, 48%, 0%);
      p {
        @include blockinP(80%, 56%, 10%);
      }
    }
  }
}
#s1s3a2 {
  height: 400vh;
  #s1s3a2b1.background {
    .block {
      @include blockin(100%, 100%, 0%, 0%);
      .backgroundImg {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.79), rgba(0, 0, 0, 0.79)), url("/assets/Mobile/Intro-Section1/1.3.3 Background_Mobile.jpg");
      }
    }
  }
  #s1s3a2b2 {
    .fake-header {
      @include fakinH(2vh, 0%);
    }
    .fake-footer {
      @include fakinF(2vh, 30%);
    }
    .block {
      @include blockin(100%, 8%, 27%, 0%);
      p {
        @include blockinP(80%, 22%, 10%);
      }
    }
  }
  #s1s3a2b4 {
    .block {
      @include blockin(100%, 23%, 5%, 0%);
      img {
        @include blockinImg(80%, 62vh, 24%);
      }
    }
  }
  #s1s3a2b4-1 {
    .block {
      @include blockin(100%, 15%, 42%, 0%);
      img {
        @include blockinImg(80%, 62vh, 25%);
      }
    }
  }
  #s1s3a2b3 {
    .fake-header {
      @include fakinH(2vh, 0%);
    }
    .fake-footer {
      @include fakinF(2vh, 0);
    }
    .block {
      @include blockin(100%, 8%, 57%, 0%);
      p {
        @include blockinP(80%, 5%, 10%);
      }
    }
  }
  #s1s3a2b5 {
    .block {
      @include blockin(100%, 20%, 68%, 0%);
      img {
        @include blockinImg(80%, 62vh, 25%);
      }
    }
  }
  #s1s3a2b6 {
    .fake-header {
      @include fakinH(2vh, 0%);
    }
    .fake-footer {
      @include fakinF(2vh, -100vh);
    }
    .block {
      @include blockin(100%, 8%, 89%, 0%);
      p {
        @include blockinP(80%, 5%, 10%);
      }
    }
  }
}
#s1s3a3 {
  height: 300vh;
  #s1s3a3b1.background {
    .block {
      @include blockin(100%, 100%, 0%, 0%);
      .backgroundImg {
        background-image:linear-gradient(to bottom, rgba(9, 27, 22, 0.89), rgba(9, 27, 22, 0.89)), url("/assets/Mobile/Intro-Section1/1.3.3 Background_Mobile.jpg");
      }
    }
  }
  #s1s3a3b2 {
    .fake-header {
      @include fakinH(2vh, 0%);
    }
    .fake-footer {
      @include fakinF(2vh, 0);
    }
    .block {
      @include blockin(100%, 8%, 35%, 0%);
      p {
        @include blockinP(80%, 22%, 10%);
      }
    }
  }
  #s1s3a3b4 {
    .block {
      @include blockin(100%, 30%, 5%, 0%);
      img {
        @include blockinImg(80%, 50vh, 20%);
      }
    }
  }
  #s1s3a3b3 {
    .fake-header {
      @include fakinH(2vh, 0%);
    }
    .fake-footer {
      @include fakinF(2vh, 0);
    }
    .block {
      @include blockin(100%, 8%, 85%, 0%);
      p {
        @include blockinP(80%, 22%, 10%);
      }
    }
  }
  #s1s3a3b5 {
    .block {
      @include blockin(100%, 30%, 55%, 0%);
      img {
        @include blockinImg(80%, 50vh, 20%);
      }
    }
  }
  #s1s3a3b6 {
    .block {
      @include blockin(100%, 14%, 67%, 0%);
      img {
        @include blockinImg(25%, 62vh, 20%);
      }
    }
  }
}
#s1s3a4 {
  height: 600vh;
  #s1s3a4b1.background {
    .block {
      @include blockin(100%, 100%, 0%, 0%);
      .backgroundImg {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.59), rgba(0, 0, 0, 0.59)), url("/assets/Mobile/Intro-Section1/1.3.5 Background_MB.jpg");
      }
    }
  }


  #s1s3a4b2 {
    .fake-header {
      @include fakinH(2vh, 0%);
    }
    .fake-footer {
      @include fakinF(2vh, 0);
    }
    .block {
      @include blockin(100%, 5%, 28%, 0%);
      p {
        @include blockinP(80%, 40%, 10%);
      }
    }
  }
  #s1s3a4b3 {
    .fake-header {
      @include fakinH(2vh, 0%);
    }
    .fake-footer {
      @include fakinF(2vh, 0);
    }
    .block {
      @include blockin(100%, 5%, 58%, 0%);
      p {
        @include blockinP(80%, 22%, 10%);
      }
    }
  }
  #s1s3a4b4 {
    .fake-header {
      @include fakinH(2vh, 0%);
    }
    .fake-footer {
      @include fakinF(2vh, 0);
    }
    .block {
      @include blockin(100%, 5%, 88%, 0%);
      p {
        @include blockinP(80%, 22%, 10%);
      }
    }
  }


  #s1s3a4b5 {
    .block {
      @include blockin(100%, 20%, 8%, 0%);
      img {
        @include blockinImg(80%, 50vh, 25%);
      }
    }
  }
  #s1s3a4b6 {
    .block {
      @include blockin(100%, 20%, 38%, 0%);
      img {
        @include blockinImg(80%, 50vh, 25%);
      }
    }
  }
  #s1s3a4b7 {
    .block {
      @include blockin(100%, 20%, 68%, 0%);
      img {
        @include blockinImg(100%, 45vh, 20%);
      }
    }
  }
  // #s1s3a4b8 {
  //   .block {
  //     @include blockin(100%, 18%, 80%, 0%);
  //     img {
  //       @include blockinImg(28%, 62vh, 20%);
  //     }
  //   }
  // }
}
#s1s3a5 {
  min-height: 500vh;
  #s1s3a5b1.background {
    .block {
      @include blockin(100%, 100%, 0%, 0%);
      .backgroundImg {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.59), rgba(0, 0, 0, 0.59)), url("/assets/Mobile/Intro-Section1/1.3.5 Background_MB.jpg");
      }
    }
  }

  #s1s3a5b2 {
    .fake-header {
      @include fakinH(5vh, -5%);
    }
    .fake-footer {
      @include fakinF(15vh, 0%);
    }
    .block {
      @include blockin(100%, 100%, 0%, 0%);
      p {
        z-index: 3;
        @include blockinP(80%, 70%, 10%);
      }
    }
  }
  #s1s3a5b3 {
    .block {
      @include blockin(100%, 25%, 0%, 0%);
      img {
        @include blockinImg(100%, 45vh, 25%);
      }
    }
  }
  #s1s3a5b4 {
    .block {
      @include blockin(100%, 25%, 35%, 0%);
      img {
        @include blockinImg(100%, 45vh, 25%);
      }
    }
  }
  #s1s3a5b5 {
    .block {
      @include blockin(100%, 25%, 70%, 0%);
      img {
        @include blockinImg(100%, 45vh, 25%);
      }
    }
  }
}
#s1s3a6 {
  height: 600vh;
  #s1s3a6b1 {
    .block {
      @include blockin(100%, 100%, 0%, 0%);
      .backgroundImg {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.59), rgba(0, 0, 0, 0.59)), url("/assets/Mobile/Intro-Section1/1.3.5 Background_MB.jpg");
      }
    }
  }
  #s1s3a6b2 {
    .fake-header {
      @include fakinH(2vh, 0%);
    }
    .fake-footer {
      @include fakinF(2vh, 0);
    }
    .block {
      @include blockin(100%, 33%, 9%, 0%);
      img {
        @include blockinImg(80%, 50vh, 20%);
        margin-bottom: 10rem;
      }
      p {
        @include blockinP(80%, 55%, 10%);
      }
    }
  }
  #s1s3a6b3 {
    .fake-header {
      @include fakinH(2vh, 0%);
    }
    .fake-footer {
      @include fakinF(2vh, 0);
    }
    .block {
      @include blockin(85%, 10%, 63%, 15%);
      p {
        @include blockinP(80%, 22%, 10%);
      }
    }
  }
  
  
  #s1s3a6b4 {
    .block {
      @include blockin(100%, 18%, 45%, 0%);
      img {
        @include blockinImg(80%, 50vh, 25%);
      }
    }
  }
  #s1s3a6b5 {
    .block {
      @include blockin(100%, 18%, 78%, 0%);
      img {
        @include blockinImg(80%, 50vh, 40%);
      }
    }
  }
}
</style>